document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.jdg-accordion-header');
    const openClass = 'jdg-accordion--expanded';

    if (accordions) {
        accordions.forEach(accordion => {
            accordion.addEventListener('click', function (event) {
                event.preventDefault();

                if (accordion.classList.contains(openClass)) {
                    accordion.classList.remove(openClass);
                } else {
                    accordion.classList.add(openClass);
                }
            });
        });
    }
});
